import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeDataStore extends Shape {
    width = 200;
    height = 200;

    setDrawStyle(_: any): void {}

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = (height * 3) / 4 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y +
            height / 4 +
            this.getTextLineHeight(textPart) +
            (height * 3) / 4 / 2 -
            textPart.height / 2.75;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        const ctx = canv.ctx;
        ctx.save();

        const cx = x + w / 2;

        // Вертикальные центры
        const topCY = y + h / 8;
        const midCY = y + h / 3;
        const botCY = y + h * 0.83;

        // Радиусы
        const rx = w / 2;
        const ryTop = h / 8;
        const ryMid = h * 0.085;
        const ryBot = h * 0.12;

        ctx.fillStyle = shapeStyles.color;
        ctx.strokeStyle = shapeStyles.borderColor;
        ctx.lineWidth = shapeStyles.borderWidth;

        this.setStrokeType(
            shapeStyles.borderColor,
            shapeStyles.borderDashType,
            shapeStyles.borderWidth,
        );

        //верхний овал
        ctx.beginPath();
        ctx.ellipse(cx, topCY, rx, ryTop, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
        ctx.closePath();

        // заливка фигуры кроме верхнего элипса
        ctx.beginPath();
        // нижняя половина верхнего эллипса
        ctx.ellipse(cx, topCY, rx, ryTop, 0, Math.PI, 0, true);
        // правая вертикальная стенка вниз
        ctx.lineTo(x + w, botCY - ryBot);
        // верхняя половина нижнего эллипса (правая → левая)
        ctx.ellipse(cx, botCY, rx, ryBot, 0, 0, Math.PI, false);
        // левая стенка вверх
        ctx.lineTo(x, topCY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        // средний полуэлипс только обводка
        ctx.beginPath();
        ctx.ellipse(cx, midCY, rx, ryMid, 0, 0, Math.PI);
        ctx.stroke();
        ctx.closePath();

        ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="m.75 3.08911v16.32179c0 1.2918 4.70101 2.3391 10.5 2.3391 5.799 0 10.5-1.0473 10.5-2.3391v-16.32179m-21 0c0 1.29185 4.70101 2.33908 10.5 2.33908 5.799 0 10.5-1.04723 10.5-2.33908m-21 0c0-1.29185 4.70101-2.33911 10.5-2.33911 5.799 0 10.5 1.04726 10.5 2.33911m0 5.82179c0 1.2918-4.701 2.3391-10.5 2.3391-5.79899 0-10.5-1.0473-10.5-2.3391"/>
            </svg>
        `;
    }
}
